module.exports = __webpack_public_path__ + "img/camera.38dd2cbe.png";